module.exports = require("./build/ng-youtube-embed.min.js");


//////////////////
// WEBPACK FOOTER
// ng-youtube-embed (bower component)
// module id = 1474
// module chunks = 0